import React from 'react';
import { useTranslation } from 'react-i18next';
import PageBanner from '../layout/PageBanner';

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageBanner parentPage="Home" activePage="Privacy Policy" motherMenu="Privacy Policy" />

            <section className="main-legal-content" style={{ background: '#ffffff', padding: '120px 0' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div style={{ marginBottom: '40px' }}>
                                <h1 style={{ fontSize: '36px', fontWeight: '700', color: '#2c3d4f', marginBottom: '20px' }}>
                                    Privacy Policy
                                </h1>
                                <p style={{ color: '#5a6c7d', fontSize: '16px', marginBottom: '10px' }}>
                                    <strong>Last updated:</strong> {new Date().toLocaleDateString('en-GB')}
                                </p>
                            </div>

                            <div className="legal-content" style={{ color: '#5a6c7d', fontSize: '16px', lineHeight: '1.8' }}>
                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    1. Introduction
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    Pure Key Homes ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our property management services and visit our website.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    2. Information We Collect
                                </h2>
                                <p style={{ marginBottom: '15px' }}>We collect information that you provide directly to us, including:</p>
                                <ul style={{ marginBottom: '20px', paddingLeft: '30px' }}>
                                    <li style={{ marginBottom: '10px' }}>Personal identification information (name, email address, phone number)</li>
                                    <li style={{ marginBottom: '10px' }}>Property information and addresses</li>
                                    <li style={{ marginBottom: '10px' }}>Payment and billing information</li>
                                    <li style={{ marginBottom: '10px' }}>Communication preferences</li>
                                    <li style={{ marginBottom: '10px' }}>Guest information when managing reservations</li>
                                </ul>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    3. How We Use Your Information
                                </h2>
                                <p style={{ marginBottom: '15px' }}>We use the information we collect to:</p>
                                <ul style={{ marginBottom: '20px', paddingLeft: '30px' }}>
                                    <li style={{ marginBottom: '10px' }}>Provide and manage our property management services</li>
                                    <li style={{ marginBottom: '10px' }}>Communicate with you about our services</li>
                                    <li style={{ marginBottom: '10px' }}>Process payments and maintain records</li>
                                    <li style={{ marginBottom: '10px' }}>Improve our services and customer experience</li>
                                    <li style={{ marginBottom: '10px' }}>Comply with legal obligations</li>
                                </ul>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    4. Data Protection and Security
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    5. Information Sharing
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted service providers who assist us in operating our business, conducting our services, or serving you, as long as those parties agree to keep this information confidential.
                                </p>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    6. Your Rights (GDPR Compliance)
                                </h2>
                                <p style={{ marginBottom: '15px' }}>Under GDPR and Spanish data protection laws, you have the right to:</p>
                                <ul style={{ marginBottom: '20px', paddingLeft: '30px' }}>
                                    <li style={{ marginBottom: '10px' }}>Access your personal data</li>
                                    <li style={{ marginBottom: '10px' }}>Correct inaccurate data</li>
                                    <li style={{ marginBottom: '10px' }}>Request deletion of your data</li>
                                    <li style={{ marginBottom: '10px' }}>Object to processing of your data</li>
                                    <li style={{ marginBottom: '10px' }}>Request data portability</li>
                                    <li style={{ marginBottom: '10px' }}>Withdraw consent at any time</li>
                                </ul>

                                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2c3d4f', marginTop: '40px', marginBottom: '20px' }}>
                                    7. Contact Us
                                </h2>
                                <p style={{ marginBottom: '20px' }}>
                                    If you have questions about this Privacy Policy or wish to exercise your rights, please contact us at:
                                </p>
                                <p style={{ marginBottom: '5px' }}><strong>Email:</strong> info@pure-key-homes.es</p>
                                <p style={{ marginBottom: '5px' }}><strong>Phone:</strong> +34 614 005 838</p>
                                <p style={{ marginBottom: '20px' }}><strong>Address:</strong> Los Alcazares, Murcia, Spain</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PrivacyPolicy;
